import { __awaiter, __generator } from "tslib";
export function getLoggerSettings(searchConfig) {
    return __awaiter(this, void 0, void 0, function () {
        var searchSettings, clientSideRelevanceEnabled, searchInHeaderEnabled, settings;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, searchConfig];
                case 1:
                    searchSettings = _a.sent();
                    clientSideRelevanceEnabled = searchSettings.clientSideRelevanceEnabled, searchInHeaderEnabled = searchSettings.searchInHeaderEnabled;
                    settings = {
                        'searchux.clientSideRelevance': clientSideRelevanceEnabled,
                        'searchux.isCrossGeoEnabled': true,
                        'searchux.isResourceLoggingEnabled': true,
                        'searchux.useSearchBoxInTheSuiteNav': searchInHeaderEnabled,
                        /**
                         * useSearchApp is set to true in OfficeHome to get the
                         * in-SERP navigation to work.
                         */
                        'searchux.useSearchApp': true,
                    };
                    return [2 /*return*/, settings];
            }
        });
    });
}
//# sourceMappingURL=getLoggerSettings.js.map